'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import 'draft-js/dist/Draft.css'
// eslint-disable-next-line import/no-unresolved

// import { save } from 'redux/modules/saveUserData';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactDom = require('react-dom');

var _draftJs = require('draft-js');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

require('./SubSectionAnalysis.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHORT_TITLE_LOWER = 60;
var SHORT_TITLE_UPPER = 210;
var SUMMARY_LENGTH_LOWER = 210;
var SUMMARY_LENGTH_UPPER = 420;

var SHORT_TITLE_SHORTER = 'SHORT_TITLE_SHORTER';
var SHORT_TITLE_LONGER = 'SHORT_TITLE_LONGER';
var SHORT_TITLE_OK = 'SHORT_TITLE_OK';
var DOUBLE_SPACING_CORRECT = 'DOUBLE_SPACING_CORRECT';
var DOUBLE_SPACING_ERROR = 'DOUBLE_SPACING_ERROR';
var SUMMARY_LENGTH_OK = 'SUMMARY_LENGTH_OK';
var SUMMARY_LENGTH_SHORTER = 'SUMMARY_LENGTH_SHORTER';
var SUMMARY_LENGTH_LONGER = 'SUMMARY_LENGTH_LONGER';
var SUMMARY_HAS_BULLET_TRUE = 'SUMMARY_HAS_BULLET_TRUE';
var SUMMARY_HAS_BULLET_FALSE = 'SUMMARY_HAS_BULLET_FALSE';

var POSITIVE_ICON = 'POSITIVE_ICON';
var NEGATIVE_ICON = 'NEGATIVE_ICON';
var NEUTRAL_ICON = 'NEUTRAL_ICON';

var ANALYSIS_RESULT_DICT = {
  "PR": {
    "short_title_check": {
      "SHORT_TITLE_SHORTER": {
        "text": "Consider writing more information about the organization you worked at",
        "style": "NEGATIVE_ICON"
      },
      "SHORT_TITLE_LONGER": {
        "text": "Consider reducing the company information",
        "style": "NEGATIVE_ICON"
      },
      "SHORT_TITLE_OK": {
        "text": "Good job! You've written the ideal amount in your company information",
        "style": "POSITIVE_ICON"
      }
    },
    "double_spacing_check": {
      "DOUBLE_SPACING_CORRECT": {
        "text": "Good job! You have left no blank lines in this section of your resume",
        "style": "POSITIVE_ICON"
      },
      "DOUBLE_SPACING_ERROR": {
        "text": "Looks like you have left some blank lines in this section. Make sure you use \
                  appropriately use all available space in your resume to provide information",
        "style": "NEGATIVE_ICON"
      }
    }
  },
  "SUM": {
    "summary_length_check": {
      "SUMMARY_LENGTH_OK": {
        "text": "Good job! The length of your summary is appropriate as per current standards",
        "style": "POSITIVE_ICON"
      },
      "SUMMARY_LENGTH_SHORTER": {
        "text": "Consider writing more points in your summary to showcase all your achievements",
        "style": "NEGATIVE_ICON"
      },
      "SUMMARY_LENGTH_LONGER": {
        "text": "Consider reducing the length of your summary to a couple of highly impactful lines",
        "style": "NEGATIVE_ICON"
      }
    },
    "summary_has_bullet_check": {
      "SUMMARY_HAS_BULLET_TRUE": {
        "text": "Consider removing bullets from your summary. It should be in a paragraph form",
        "style": "NEGATIVE_ICON"
      },
      "SUMMARY_HAS_BULLET_FALSE": {
        "text": "Good job! Your summary is in the paragraph form and in line with current standards",
        "style": "POSITIVE_ICON"
      }
    },
    "double_spacing_check": {
      "DOUBLE_SPACING_CORRECT": {
        "text": "Good job! You have left no blank lines in this section of your resume",
        "style": "POSITIVE_ICON"
      },
      "DOUBLE_SPACING_ERROR": {
        "text": "Looks like you have left some blank lines in this section. Make sure you use \
                  appropriately use all available space in your resume to provide information",
        "style": "NEGATIVE_ICON"
      }
    }
  }
};

var SubSectionAnalysis = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    text_analysis_data: state.templateData.text_analysis_data,
    info_block: state.templateData.info_block,
    highlighted_action_verb: state.templateData.highlighted_action_verb
  };
}, {
  highlightActionVerb: templateData.highlightActionVerb
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SubSectionAnalysis, _Component);

  function SubSectionAnalysis(props) {
    (0, _classCallCheck3.default)(this, SubSectionAnalysis);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SubSectionAnalysis.__proto__ || (0, _getPrototypeOf2.default)(SubSectionAnalysis)).call(this, props));

    _this.state = {
      sectionAnalysisVisible: false,
      section_analysis_object: false
    };

    _this.findDoubleSpacing = function (entry) {

      var HTMLData = entry['description'];
      var editorState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(JSON.parse(HTMLData)));
      var lastFoundIndex = false;
      var index = 0;
      var hasDoubleSpacing = false;
      hasDoubleSpacing = editorState.getCurrentContent().getBlockMap().some(function (contentBlock) {
        if (contentBlock.getType() === 'unstyled' && contentBlock.getText() === '') {
          if (lastFoundIndex === index - 1 && lastFoundIndex) {
            return true;
          }
          lastFoundIndex = index;
        }
        index += 1;
      });
      return hasDoubleSpacing;
    };

    _this.datedSectionAnalysis = function (data_parent, data_id) {
      var experience_array = _this.props.info_block[data_parent];
      var current_experience = experience_array[data_id];

      var analyzed_data = void 0;
      var is_invalid_date = false;
      var loop_index = 0;

      // short title length check
      var short_title = current_experience['short_title'];

      var short_title_check = void 0;
      if (short_title.length > SHORT_TITLE_LOWER && short_title.length < SHORT_TITLE_UPPER) {
        short_title_check = SHORT_TITLE_OK;
      } else if (short_title.length < SHORT_TITLE_LOWER) {
        short_title_check = SHORT_TITLE_SHORTER;
      } else {
        short_title_check = SHORT_TITLE_LONGER;
      }

      // double spacing check in section
      var double_spacing_check = _this.findDoubleSpacing(current_experience) ? DOUBLE_SPACING_ERROR : DOUBLE_SPACING_CORRECT;

      var obj = {
        short_title_check: short_title_check,
        double_spacing_check: double_spacing_check
      };
      _this.setState({ section_analysis_object: obj, sectionAnalysisVisible: true });
    };

    _this.summarySectionAnalysis = function (data_parent, data_id) {
      var current_summary = _this.props.info_block[data_parent][data_id];
      var summary_length_check = void 0;
      var summary_has_bullet_check = void 0;

      var HTMLData = current_summary['description'];
      var editorState = _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(JSON.parse(HTMLData)));

      //summary length
      var summary_text = editorState.getCurrentContent().getPlainText();

      if (summary_text.length > SUMMARY_LENGTH_LOWER && summary_text.length < SUMMARY_LENGTH_UPPER) {
        summary_length_check = SUMMARY_LENGTH_OK;
      } else if (summary_text.length < SUMMARY_LENGTH_LOWER) {
        summary_length_check = SUMMARY_LENGTH_SHORTER;
      } else {
        summary_length_check = SUMMARY_LENGTH_LONGER;
      }

      //checking if summary is in paragraph form
      summary_has_bullet_check = editorState.getCurrentContent().getBlockMap().some(function (contentBlock) {
        if (contentBlock.getType() === 'unordered-list-item' || contentBlock.getType() === 'ordered-list-item') {
          return true;
        }
      });

      summary_has_bullet_check = summary_has_bullet_check ? SUMMARY_HAS_BULLET_TRUE : SUMMARY_HAS_BULLET_FALSE;

      // double spacing check in section
      var double_spacing_check = _this.findDoubleSpacing(current_summary) ? DOUBLE_SPACING_ERROR : DOUBLE_SPACING_CORRECT;

      var obj = {
        summary_length_check: summary_length_check,
        summary_has_bullet_check: summary_has_bullet_check,
        double_spacing_check: double_spacing_check
      };
      _this.setState({ section_analysis_object: obj, sectionAnalysisVisible: true });
    };

    _this.doSectionAnalysis = function (data_parent, data_id) {
      switch (data_parent) {
        case 'PR':
          _this.datedSectionAnalysis(data_parent, data_id);
          break;
        case 'SUM':
          _this.summarySectionAnalysis(data_parent, data_id);
          break;

      }
    };

    _this.closeSectionAnalysis = function () {
      _this.setState({ sectionAnalysisVisible: false });
    };

    return _this;
  }

  (0, _createClass3.default)(SubSectionAnalysis, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          sectionAnalysisVisible = _state.sectionAnalysisVisible,
          section_analysis_object = _state.section_analysis_object;
      var _props = this.props,
          data_parent = _props.data_parent,
          data_id = _props.data_id;

      return _react2.default.createElement(
        'div',
        { style: { position: 'relative' }, className: 'subSectionAnalysis subSectionAnalysis-' + data_parent },
        _react2.default.createElement(_semanticUiReact.Icon, { color: 'blue', onClick: function onClick(e) {
            return _this2.doSectionAnalysis(data_parent, data_id);
          }, style: { position: 'absolute', fontSize: '18px' }, name: 'lightbulb outline' }),
        sectionAnalysisVisible && _react2.default.createElement(SectionAnalysisTextBox, {
          data_parent: data_parent,
          section_analysis_object: section_analysis_object,
          closeSectionAnalysis: this.closeSectionAnalysis
        })
      );
    }
  }]);
  return SubSectionAnalysis;
}(_react.Component)) || _class);
exports.default = SubSectionAnalysis;

var SectionAnalysisTextBox = function (_Component2) {
  (0, _inherits3.default)(SectionAnalysisTextBox, _Component2);

  function SectionAnalysisTextBox(props) {
    (0, _classCallCheck3.default)(this, SectionAnalysisTextBox);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (SectionAnalysisTextBox.__proto__ || (0, _getPrototypeOf2.default)(SectionAnalysisTextBox)).call(this, props));

    _this3.hasSomeParentTheClass = function (element, classname) {
      if (element.className) {
        if (element.className.split(' ').indexOf(classname) >= 0) return true;
      }
      return element.parentNode && _this3.hasSomeParentTheClass(element.parentNode, classname);
    };

    _this3.closeTextAnalysis = function (e) {
      if (_this3.hasSomeParentTheClass(e.target, 'textAnalysisWrapper') || _this3.hasSomeParentTheClass(e.target, 'sectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'subSectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'resumeAnalysisBox')) {
        _this3.props.closeSectionAnalysis();
      }
    };

    return _this3;
  }

  (0, _createClass3.default)(SectionAnalysisTextBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          data_parent = _props2.data_parent,
          section_analysis_object = _props2.section_analysis_object;


      var style_dict = {
        "POSITIVE_ICON": { color: 'green', icon: 'checkmark' },
        "NEGATIVE_ICON": { color: 'red', icon: 'close' },
        "NEUTRAL_ICON": { color: 'orange', icon: 'exclamation circle' }
      };

      return _react2.default.createElement(
        _semanticUiReact.Card,
        { className: 'textanalysis-card' },
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Header,
            null,
            _react2.default.createElement(
              'div',
              null,
              'Section Analysis'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', style: { cursor: 'pointer' }, color: 'black', onClick: function onClick(e) {
                return _this4.props.closeSectionAnalysis();
              } })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { style: { padding: '5px', maxHeight: '300px', overflow: 'auto', scrollBehavior: 'auto' } },
          _react2.default.createElement(
            _semanticUiReact.Feed,
            { className: 'textAnalysis-feed', size: 'small', style: { fontSize: '10px' } },
            (0, _keys2.default)(section_analysis_object).map(function (key) {
              var val = section_analysis_object[key];
              var point_text = ANALYSIS_RESULT_DICT[data_parent][key][val]['text'];
              var style_tag = ANALYSIS_RESULT_DICT[data_parent][key][val]['style'];
              var style = style_dict[style_tag];
              return _react2.default.createElement(
                _semanticUiReact.Feed.Event,
                null,
                _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: style.icon, style: { color: style.color } }),
                _react2.default.createElement(
                  _semanticUiReact.Feed.Content,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Summary,
                    null,
                    point_text
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return SectionAnalysisTextBox;
}(_react.Component);

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SubSectionAnalysis/SubSectionAnalysis.js
// module id = 1750
// module chunks = 0